import { action } from 'typesafe-actions';

import { Role, RolesActionTypes } from './types';

export const toggleRoleModal = (isOpen: boolean, role?: Role) => action(RolesActionTypes.TOGGLE_ROLES_MODAL, { isOpen, role });

export const updateRoleValue = (key: keyof Role, value: string | null | number[] | boolean) => action(RolesActionTypes.UPDATE_ROLE_VALUE, { key, value });

export const upsertRoleFailed = (error: string) => action(RolesActionTypes.UPSERT_ROLE_FAILED, error);
export const upsertRoleSuccessful = (allRoles: Role[]) => action(RolesActionTypes.UPSERT_ROLE_SUCCESSFUL, allRoles);
export const upsertRoleStarted = () => action(RolesActionTypes.UPSERT_ROLE_STARTED);

export const toggleDeleteRoleConfirmationModal = (isOpen: boolean, role?: Role) => action(RolesActionTypes.TOGGLE_DELETE_ROLE_CONFIRMATION_MODAL, { isOpen, role });

export const deleteRoleStarted = (roleId: number) => action(RolesActionTypes.DELETE_ROLE_STARTED, { roleId });
export const deleteRoleSuccessful = (allRoles: Role[]) => action(RolesActionTypes.DELETE_ROLE_SUCCESSFUL, allRoles);
export const deleteRoleFailed = (error: string) => action(RolesActionTypes.DELETE_ROLE_FAILED, error);

export const fetchAllRolesFailed = (error: string) => action(RolesActionTypes.FETCH_ALL_ROLES_FAILED, error);
export const fetchAllRolesSuccessful = (allRoles: Role[]) => action(RolesActionTypes.FETCH_ALL_ROLES_SUCCESSFUL, allRoles);
export const fetchAllRolesStarted = (clientId?: number) => action(RolesActionTypes.FETCH_ALL_ROLES_STARTED, { clientId });

export const duplicateRole = (role: Role) => action(RolesActionTypes.DUPLICATE_ROLE, role);
